import { memo, useCallback } from 'react';
import cn from 'classnames';
import { IconButton } from 'src/components/buttons';
import { RequireLoginButton } from '../RequireLoginButton';
import { useDispatch, useSelector } from 'react-redux';
import { likeSelector } from 'src/selectors/user';
import * as UserAction from 'src/redux/actions/user/dispatchActions';
import styles from './style.module.scss';
import { IContent } from 'src/interface';
import { Element } from 'src/components';

interface IProps {
    className?: string;
    content: IContent;
    text?: string;
}

const LikeButton = ({ className, content, text }: IProps) => {
    const { contentId, totalLike = 0 } = content;
    const likes = useSelector(likeSelector);
    const isLike = likes.indexOf(contentId) > -1;
    const dispatch = useDispatch();
    const handleClick = useCallback(() => {
        if (!isLike) {
            dispatch(UserAction.like(contentId));
        }
    }, [isLike, contentId]);

    const textNumber = text ? text : isLike ? totalLike + 1 : totalLike;

    return (
        <RequireLoginButton onClickFn={handleClick}>
            <IconButton
                renderAs="button"
                title="Thích"
                className={cn(styles['btn-like'], className, {
                    [styles['is-like']]: isLike,
                })}
                icon="thumbs-up"
                triggerBefore={<Element renderAs="span">{textNumber}</Element>}
            ></IconButton>
        </RequireLoginButton>
    );
};

export default memo(LikeButton);
